// ---------------------------------------------------------------------------
// csrf
//
// Reads the Rails CSRF token from the meta tag written by csrf_meta_tags in
// the application layout. Required for non-Inertia multipart XHR requests
// (document upload, progress tracking). Inertia manages its own CSRF header
// for Inertia visits; this util is only needed when fetch/XHR is issued
// outside an Inertia visit.
//
// Surface-agnostic: carries no privileged data. Safe for all three bundles
// (register, portal, admin), though only portal/admin surfaces issue
// authenticated requests that need a CSRF token.
// ---------------------------------------------------------------------------

/**
 * Returns the value of the Rails CSRF token meta tag, or null if the tag is
 * absent or has no content attribute. The tag is written by the server as:
 *   <meta name="csrf-token" content="<token>">
 */
export function getCsrfToken(): string | null {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
  if (!meta) return null
  return meta.getAttribute('content')
}
